import PortfolioItem from './PortfolioItem';
import Portfolio from './Portfolio';

export {PortfolioItem,Portfolio};



// WEBPACK FOOTER //
// ./src/components/portfolio/index.js